
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DescribeData from "./describe.vue";
import dimendionDesc from "@/lib/dimension/high-low-desc";
import H5ReportDialog from "@/views/paper/paper-result-report/component-new-h5/dialog/index.vue";
import { TacPsycGauge } from "@/lib/model/exam/candidate-result";

@Component({ components: { DescribeData, H5ReportDialog } })
export default class Psychological extends Vue {
  @Prop({ type: TacPsycGauge, default: () => new TacPsycGauge() })
  psyGauge!: TacPsycGauge;

  showReadingGuide = false;
  defShow5Dim = 5;
  showAllDim = false;

  @Watch("showReadingGuide")
  handleDialogChange(val: boolean) {
    if (val) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  }

  // 纬度(高/低)描述
  dimendionDescription(dimensionName: string): { h?: string; l?: string } {
    if (!dimendionDesc[dimensionName]) return {};
    return dimendionDesc[dimensionName];
  }
}
